import { gql } from "apollo-angular";

export const GET_FPCS_QUERY = gql`query configuratorFpcs {
    configuratorFpcs {
        presignedUrl
    }
  }
  `